import EditButtonStyle from './EditButton.styles';
import EditIcon from '@/assets/images/edit.svg?component';

type EditButtonProps = {
  onClick?: () => void;
};

export const EditButton = ({ onClick }: EditButtonProps) => (
  <EditButtonStyle onClick={onClick}>
    <EditIcon/>
  </EditButtonStyle>
);
